export { default as getTransactionTableHistoryStructure } from './table-history-constructor';
